import { create } from 'zustand';

interface EdgeActiveState {
  activeEdgeIds: Set<string>;
  setActiveEdgeIds: (ids: Set<string>) => void;
}

export const useEdgeActiveStore = create<EdgeActiveState>((set, get) => ({
  activeEdgeIds: new Set<string>(),
  // P1: 添加内容比较，避免相同内容的 Set 触发所有 CustomEdge selector 重新执行
  // 之前直接 set({ activeEdgeIds: ids })，即使内容相同也会触发 store 更新
  setActiveEdgeIds: (ids) => {
    const current = get().activeEdgeIds;
    // 快速路径：引用相同
    if (current === ids) return;
    // 快速路径：大小不同，一定有变化
    if (current.size !== ids.size) {
      set({ activeEdgeIds: ids });
      return;
    }
    // 慢速路径：大小相同，逐个比较
    let same = true;
    for (const id of ids) {
      if (!current.has(id)) { same = false; break; }
    }
    if (!same) {
      set({ activeEdgeIds: ids });
    }
  },
}));
